namespace GeniuzPOS {
    export interface GetEANDigit13Request extends Serenity.ServiceRequest {
        Prefix?: string;
        Length?: number;
    }
}
